import { PeekyEmitter } from "@shared/peeky.emitter";
import { ElementClass, UrlParam, Peeky, RootKey, RootUrlParam, ElementUrlParam } from "./peeky";
import { PeekyElement } from "./peeky.element";
import $ from 'jquery';

type StateOptions = {
	DOM?: HTMLElement,
  $dom?: JQuery,
  element: PeekyElement,
  param: RootUrlParam,
  initialDocument: boolean
}

export class PeekyState extends PeekyEmitter {

	DOM: HTMLElement;
  $dom: JQuery;
  parent: PeekyElement;
  element: PeekyElement;
  site: Peeky;

  children: { [key: string]: PeekyElement };
  _param: ElementUrlParam;
  _property: any;
  _shown: boolean;
  _serial?: string;
  _attached: boolean;

  constructor(options: StateOptions) {
    super();
    this.parent = this.element = options.element;
    this.site = this.element.site;

		if (options.DOM) {
			this.DOM = options.DOM;
			this.$dom = $(options.DOM);
		} else {
			this.$dom = options.$dom;
			this.DOM = options.$dom[0];
		}
	
    if (this.$dom) {
      this.$dom.data('kkState', this);
    }

    if (!this.element.currentState) {
      this.element.currentState = this;
    }
    
    this.children = {};
    this._param = {};
    this._property = {};
    this._shown = false;

    // Add parameters
    if (options.param) {
      let parentLevel = (this.element.parent) ? this.element.parent.pathLevel() : 0;
      options.param[this.element.key] = $.extend(true, {}, options.param[this.element.key]);
      // If a path is requested and we're catching paths, add it
			let rootArg: string[] | undefined = typeof(options.param[RootKey]) === 'object' ? options.param[RootKey]._arg : undefined;
			let elementArg: string[] | undefined = typeof(options.param[this.element.key]) === 'object' ? options.param[this.element.key]._arg : undefined;

      if (
        this.element.catchPath() && 
				rootArg &&
				!elementArg
      ) {
				elementArg = options.param[this.element.key]._arg = [];
        for (let i=parentLevel; i<this.element.pathLevel(); i++) {
          // Replace with lockPath if it exists
          if (this.element.lockPath[i-parentLevel]) {
            elementArg[i-parentLevel] = this.element.lockPath[i-parentLevel] || '';	
          }
          // Replace with defaultPath if we're in wrong path-tree
          else if (!this.element.catchPathTreeCompare(options.param)) {
            elementArg[i-parentLevel] = this.element.defaultPath[i-parentLevel] || '';	
          }
          // Handle as normal
          else {
            elementArg[i-parentLevel] = rootArg[i] || '';
          }

          // Replace with multiPath if it exists
          if (this.element.multiPath[i-parentLevel]) {
            if (this.element.multiPath[i-parentLevel] === true) {
              elementArg[i-parentLevel] = '__pkmulti';
            } else if ($.inArray(elementArg[i-parentLevel], this.element.multiPath[i-parentLevel]) >= 0) {
              elementArg[i-parentLevel] = '__pkmulti';
            }
          }
        }
      }
      this.param(options.param[this.element.key]);
    }
    
    // Add initial actions
    for (let action in actions) {
      this.bindAction(action, actions[action]);
    }
    
    this.triggerAction('initState', {
      param: options.param,
      initialDocument: options.initialDocument
    });
  }


  serialize() {
		if (this._serial) {
      return this._serial;
    }
		this._serial = this.site.serialize(this.param());
		return this._serial;
	}


	param(defaults: number);
  param(defaults: boolean);
  param(values: UrlParam);
  param(key?: string, value?: any);
  param(defaults?, key?, val?) {
		let elementCatchArg = this.element.catchPath();
		if (typeof(defaults) === 'boolean') {
			defaults = elementCatchArg;
		}
		if (typeof(defaults) !== 'number') {
			val = key;
			key = defaults;
			defaults = 0;
		}
		if (typeof(key) === 'object') {
			val = key;
			for (let subkey in val) {
        this.param(subkey, val[subkey]);
      }
			return;
		}
		if (typeof(key) === 'undefined') {
			let ret = { ...this._param };
			let defaultPath = this.element.defaultPath;
			// lockPath forces path entries for a given entity. This is useful for single page sites that can have multiple path trees in the same view.
			let lockPath = this.element.lockPath;
			if (!ret._arg) {
				ret._arg = [];
			}
			for (let i=0; i<elementCatchArg; i++) {
				if (lockPath[i]) {
					ret._arg[i] = lockPath[i];
				}
				else if (i<defaults) {
					if (!ret._arg[i]) {
						ret._arg[i] = defaultPath[i];
					}
				} else if (ret._arg[i] === defaultPath[i]) {
					ret._arg[i] = undefined;
				}
			}
			return ret;
		}
		if (typeof(val) === 'undefined') {
			return this.param()[key];
		}
		this._serial = undefined;
		this._param[key] = val;
	}


  getArg(no) {
		let param = this.param(!!this.element.catchPath());
		if (!param._arg) {
			return undefined;
		}
		no = no || 0;
		let arg = param._arg[no];
		if (!arg) {
			return arg;
		} else {
			return decodeURIComponent(arg);
		}
	}


  getArgs(defaults) {
		let param = this.param(defaults);
		let args;
		if (!param._arg) {
			args = [];
		} else {
			args = param._arg.slice();
		}
		return args;
	}


  clear() {
		this._param = {};
		this._serial = undefined;
		return this;
	}

	
	$find(selector: string) {
		return this.$dom.find(selector).not(this.$dom.find('.' + ElementClass + ' '  + selector));
	}
	

	equals(state: PeekyState | ElementUrlParam | string) {
		for (let i=0; i<=this.element.catchPath(); i++) {
			if (this.site.compareStates(this.param(i), state)) {
				return true;
			} 
		}
		return false;
	}
	

	attached(execOnAttached) {
		if (typeof(execOnAttached) === 'function') {
			this.on('attached', execOnAttached);
			if (!!this._attached) {
				execOnAttached.call(this);
			}
		} else {
			return !!this._attached;
		}
	}


	oneAttached(execOnAttached) {
		if (typeof(execOnAttached) === 'function') {
			if (!!this._attached) {
				execOnAttached.call(this);
			} else {
				this.once('attached', execOnAttached);
			}
		}
	}
	

	detached(execOnDetached) {
		if (typeof(execOnDetached) === 'function') {
			this.on('detached', execOnDetached);
			if (!this._attached) {
				execOnDetached.call(this);
			}
		} else {
			return !this._attached;
		}
	}
	

	oneDetached(execOnDetached) {
		if (typeof(execOnDetached) === 'function') {
			if (!this._attached) {
				execOnDetached.call(this);
			} else {
				this.once('detached', execOnDetached);
			}
		}
	}

	
	shown(callback?): boolean {
		let shown = this._shown;
		if (shown && this.element !== this.element.root && this.element.parentState) {
			shown = this.element.parentState.shown();
		}
		if (callback) {
			if (shown) {
				callback.call(this);
			} else {
				this.once('stateShown', callback);
			}
		}
    return shown;
	}
}



let actions = {
		
	initState: async function(this: PeekyState, param) {
		// Look for children elements to add
		let that = this;
		let $children = this.$find('.' + ElementClass);

		for (let i=0; i<$children.length; i++) {
			let child = $children[i];
			let key = child.dataset.key;
			let id = child.id;
			if (!key && id) {
        key = id.substr(ElementClass.length+1);
      }
			if (!key) {
        key = 'anon_' + ++this.site.anonStateCounter;
      }
			 let newElement = new PeekyElement(key, {
        DOM: child,
        param: param.param,
        parent: this.element,
        parentState: this,
        initialDocument: param.initialDocument
      });
			this.children[key] = newElement;
			
			this.once('postLoadedState', function loadedState(this: PeekyState, param, state) {
				// If state is given, the event has bubbled
				if (state) {
          return that.once('postLoadedState', loadedState);
        }
				that.children[key].triggerAction('loadedElement');
			});
		}

		param.$children = $children;
	},

	
	// Make sure action is only triggered on really attached states
	preAttached: async function(this: PeekyState, param) {
		if (this._attached) {
      throw undefined;
    }
		this._attached = true;
	},

	
	// Make sure action is only triggered on really detached states
	preDetached: async function(this: PeekyState, param) {
		if (!this._attached) {
      throw undefined;
    }
		this._attached = false;
	},
	
	
	// Remove state
	removeState: async function(this: PeekyState, param) {
		let children = this.children;
		let childrenKeys = Object.keys(children);
		let states = this.parent.states;
		let index = states.indexOf(this);

    for (let i=0; i<childrenKeys.length; i++) {
      let child = childrenKeys[i];
      await children[child].triggerAction('removeElement');
    }
		
    while (index >= 0) {
      states.splice(index, 1);
      index = states.indexOf(this);
    }
    if (this.$dom) {
      this.$dom.remove();
    }
	},
	
	
	// Detect catchAnchor pathnames
	stateShown: async function(this: PeekyState, param) {
		if (this.element.catchAnchor) {
			let pkparam = this.site.param();
			let pathLevel = this.element.pathLevel();
			let anchor = pkparam[RootKey]._arg[pathLevel] || '';
			if (anchor) {
				//$('#' + anchor).scrollTo(200);
			} else {
				//$.scrollTo(0, 200);
			}
		}
		this._shown = true;
	},


	stateHidden: async function(this: PeekyState, param) {
		// trigger for all children
		for (let k in this.children) {
			this.children[k].state().triggerAction('stateHidden');
		}
		this._shown = false;
	}
};
